import { Component, OnInit } from '@angular/core';

import { AviationEvent } from '../../shared/models/aviation-event.model';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { UserInfo } from '../../shared/models/user-info.model';
import { UserService } from '../../shared/user/user.service';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-favorite-events-list',
  templateUrl: './favorite-events-list.component.html',
  styleUrls: ['./favorite-events-list.component.scss']
})
export class FavoriteEventsListComponent implements OnInit {
  aviationEvents: Array<AviationEvent>;
  favoritesPromise: StatefulPromise<AviationEvent[]>;
  userInfo: UserInfo = null;

  constructor(private _aviationEventsService: AviationEventsService,
              private _userService: UserService) { }

  ngOnInit() {
    this._userService.userInfo.pipe(first(v => v !== null)).subscribe(e => this._onUserInfoUpdate(e));
  }

  private _onUserInfoUpdate(e: UserInfo) {
    this.userInfo = e;

    const idList = $.map(this.userInfo.favoriteEvents, function(a) {
      return a.eventId;
    }).join();
    if (idList) {
      this.favoritesPromise = new StatefulPromise(this._aviationEventsService.getFavoriteEvents(idList));
    } else {
      this.favoritesPromise = null;
    }
  }

  private get _favorites(): Array<AviationEvent> {
    if (!this.favoritesPromise || this.favoritesPromise.state !== PromiseState.Fulfilled) {
      return null;
    }
    return this.favoritesPromise.value;
  }

  get favorites(): Array<AviationEvent> {
    return this._favorites;
  }
}
